var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "44px",
    viewBox: "0 0 32 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#181C4B",
    points: "0 44 0 0 32 0 32 44 16.5 44"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    fill: "#00FFC2",
    points: "21 22 16 17 11 22 16 27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01);
export default __webpack_public_path__ + "static/media/01.6da9cf5dc3a209ecc6239cea8a193b66.svg";
export { ForwardRef as ReactComponent };